import React from 'react';
import { getSite } from '@/common/constants/platform-constants';
import s from './index.module.less';
import { SiteQrCode } from '../method';

const PromotionProductions = () => (
  <div className={s.join}>
    <div className={s.title}>联系我们</div>
    <div>有任何使用问题或意见反馈，欢迎加入官方群与我们交流</div>
    <img className={s.QRCode} src={SiteQrCode[getSite()]} alt="" />
  </div>
);
export default PromotionProductions;
